const choices = {
    minimum: 'Celui qui rapporte un rendement minimum mais sans aucun risque de perte de capital',
    medium: 'Celui qui rapporte un rendement supérieur avec un risque de perte en capital',
    maximum: 'Celui qui rapporte un rendement très supérieur mais avec un risque plus important de perte en capital ',
};

export default choices;
